import React, { Component } from "react"
import FlightSearchForm from "../flight/flight-search-form"
import FlightSearchResult from "../flight/flight-search-result"

class TravelGuideStep1 extends Component {
  state = {
    invalidData: false,
  }

  componentDidUpdate(prevPros) {
    const { departingFlightId, arrivingFlightId } = this.props
    if (prevPros.departingFlightId !== departingFlightId || prevPros.arrivingFlightId !== arrivingFlightId) this.setState({ invalidData: false })
  }

  handleLeaveStep1() {
    const { departingFlightId } = this.props
    if (departingFlightId?.length > 0) {
      this.props.stepButtonClickHandler({ activeStep: 2 })
    } else {
      this.setState({ invalidData: true })
    }
  }
  render() {
    const { config, activeTab, departureDate, arrivalDate, query, time, departingFlightId, arrivingFlightId } = this.props
    return (
      <React.Fragment>
        <div className="flights js--flights">
          <header className="flights__header js--flights__header">
            <div className="tab-panes tab-panes--two-tabs">
              <nav className="tab-panes__navigation">
                <div className={`tab-panes__navigation__primary ${config.tabsPaneBackgroundColor}`}>
                  <div className="w--wider">
                    <div className="tab-panes__navigation__primary__inner">
                      <button className={`button button--toggle ${activeTab === 1 && "is-active"}`} onClick={() => this.props.tabClickHandler(1)}>
                        <span className="icon">
                          <svg className="svg-icon svg-icon--planetakeoff">
                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-planetakeoff">
                              &nbsp;
                            </use>
                          </svg>
                        </span>
                        <span className="text">{config.firstTabName || "Afrejse"}</span>
                      </button>
                      <button className={`button button--toggle ${activeTab === 2 && "is-active"}`} onClick={() => this.props.tabClickHandler(2)}>
                        <span className="icon">
                          <svg className="svg-icon svg-icon--planelanding">
                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-planelanding">
                              &nbsp;
                            </use>
                          </svg>
                        </span>
                        <span className="text">{config.secondTabName || "Hjemkomst"}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </nav>
            </div>

            <FlightSearchForm
              header={activeTab === 1 ? config.firstTabSearchHeader : config.secondTabSearchHeader}
              query={query}
              config={config}
              minDate={activeTab === 1 ? departureDate : arrivalDate}
              selectedDate={activeTab === 1 ? departureDate : arrivalDate}
              time={time}
              activeTab={activeTab}
              departingFlightId={departingFlightId}
              arrivingFlightId={arrivingFlightId}
              dateChangeHandler={this.props.dateChangeHandler.bind(this)}
              timeChangeHandler={this.props.timeChangeHandler.bind(this)}
              queryChangeHandler={this.props.queryChangeHandler.bind(this)}
              searchClickHandler={this.props.searchClickHandler.bind(this)}
              writeToState={this.props.writeToState.bind(this)}
            />
          </header>

          <FlightSearchResult
            query={query}
            config={config}
            flights={activeTab === 1 ? this.props.departingFlights : this.props.arrivingFlights}
            chosenFlightId={activeTab === 1 ? this.props.departingFlightId : this.props.arrivingFlightId}
            activeTab={activeTab}
            buttonClickHandler={this.props.buttonClickHandler.bind(this)}
            stepButtonClickHandler={this.props.stepButtonClickHandler.bind(this)}
          />
        </div>

        <div className="w--wider">
          {this.state.invalidData && (
            <div className="form">
              <div className="form__section ">
                <div className="form__section__inner is-invalid ">
                  <span className="form__notice align-center">
                    {config.noFlightChosenErrorText || "Du skal mindst vælge én afrejse eller hjemrejse"}
                  </span>
                </div>
              </div>
            </div>
          )}
          <div className="button-container">
            {this.props.activeTab === 2 ? (
              <React.Fragment>
                <button
                  className={`button button--small rm-this-class rm-this-class-hide-default no-shadow ${
                    config.goBackButtonBackgroundColor || "button--general is-grey-text"
                  }`}
                  onClick={() => this.props.stepButtonClickHandler({ activeTab: 1 })}
                >
                  <span className="text strong">{config.goBackButtonText || "Tilbage"}</span>
                </button>

                <button
                  className={`button button--small rm-this-class rm-this-class-hide-default no-shadow ${
                    config.nextButtonBackgroundColor || "button--general is-blue-text"
                  }`}
                  onClick={() => this.handleLeaveStep1()}
                >
                  <span className="text strong">{config.nextButtonText || "Fortsæt"}</span>
                </button>
              </React.Fragment>
            ) : (
              <button
                className={`button button--small rm-this-class rm-this-class-hide-default no-shadow ${
                  config.nextButtonBackgroundColor || "button--general is-blue-text"
                }`}
                onClick={() => this.props.stepButtonClickHandler({ activeTab: 2 })}
              >
                <span className="text strong">{config.nextButtonText || "Fortsæt"}</span>
              </button>
            )}
          </div>
        </div>
      </React.Fragment>
    )
  }
}
export default TravelGuideStep1
